module.exports = __webpack_public_path__ + "3e5bba942d0037f18e95febfc02670fc.svg";